module.exports = __webpack_public_path__ + "static/media/the-brinton-museum.16fa438f.jpg";